// src/pages/LoginPage.tsx
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

// map each code to its allowed userId
const CODE_TO_USER: Record<string, string> = {
  ADM2025A: '1',   // Code ADM2025A ➔ userId "1"
  ADM2025B: '2',   // Code ADM2025B ➔ userId "2"
  // add more code → userId pairs here...
};

export default function LoginPage() {
  const [userId, setUserId]       = useState('');
  const [email, setEmail]         = useState('');
  const [accessCode, setAccessCode] = useState('');
  const [error, setError]         = useState('');
  const auth                       = useAuth();
  const navigate                   = useNavigate();
  const location                   = useLocation() as { state?: { from?: Location } };

  // Where to redirect after login (default to '/admin')
  const fromPath = location.state?.from?.pathname || '/admin';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    // 1) All fields are required
    if (!userId.trim() || !email.trim() || !accessCode.trim()) {
      setError('User ID, email, and access code are all required.');
      return;
    }

    // 2) Code must exist
    const mappedUser = CODE_TO_USER[accessCode.trim()];
    if (!mappedUser) {
      setError('Invalid access code.');
      return;
    }

    // 3) Code must match the entered User ID
    if (mappedUser !== userId.trim()) {
      setError('Access code does not match the User ID.');
      return;
    }

    // 4) (Optional) verify email against your back-end here

    // 5) Success! store in context and redirect
    auth.login(userId.trim(), email.trim());
    navigate(fromPath, { replace: true });
  };

  return (
    <div className="container p-4" style={{ maxWidth: 400, margin: '4rem auto' }}>
      <h2 className="mb-4">Admin Login</h2>
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        {/* User ID */}
        <div className="mb-3">
          <label className="form-label">User ID</label>
          <input
            className="form-control"
            value={userId}
            onChange={e => setUserId(e.target.value)}
            required
          />
        </div>

        {/* Email */}
        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
        </div>

        {/* Access Code */}
        <div className="mb-3">
          <label className="form-label">Access Code</label>
          <input
            className="form-control"
            value={accessCode}
            onChange={e => setAccessCode(e.target.value)}
            required
          />
          <div className="form-text">
            Enter your personal 8-character access code.
          </div>
        </div>

        <button type="submit" className="btn btn-primary w-100">
          Log In
        </button>
      </form>
    </div>
  );
}
